
import { Component, Prop, Vue } from 'vue-property-decorator'

import { RallyRoundButton } from '@/lib/models/RallyRoundButton'

import BacRouterLinkOrA from '@/components/BacRouterLinkOrA.vue'
import { Team } from '@/lib/models/Team'
import { Http } from '../../lib/utils/Http'
import { SerializationHelper } from '@/lib/utils/SerializationHelper'

@Component({
  components: {
    BacRouterLinkOrA
  }
})
export default class BaseButton extends Vue {
  @Prop({ default: new RallyRoundButton() }) button!: RallyRoundButton

  imageLink = ''
  team: Team = new Team()

  async loadTeam () {
    const res = await Http.request(`/api/rally-round/${this.$route.params.rallyRoundId}/team/logged-in`)
    this.team = SerializationHelper.toInstance(new Team(), (await res.json()))
    if (this.button?.link && this.team.id) {
      this.button.link = this.button.link.replace(':teamId', this.team.id.toString())
    }
  }

  get buttonLink () {
    if (this.button?.link?.startsWith('/teamarea/')) {
      return this.button.link.substring('/teamarea'.length)
    }
    if (this.button?.link?.includes(':teamId') && this.team.id) {
      this.button.link = this.button.link.replace(':teamId', this.team.id.toString())
    }
    return this.button.link
  }

  mounted () {
    this.loadButtonImage()
    console.log('link: ' + this.button.link)
    if (this.button.link?.includes(':teamId')) {
      console.log('found team id, loading team...')
      this.loadTeam()
    }
    console.log("couldn't find team id")
  }

  async loadButtonImage () {
    this.imageLink = (await import(`@/assets/img/buttons/${this.button.image}`)).default
  }
}
